import { render } from "./WalletExplorer.vue?vue&type=template&id=2063f2fa"
import script from "./WalletExplorer.vue?vue&type=script&lang=js"
export * from "./WalletExplorer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WalletExplorer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2063f2fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2063f2fa', __exports__)) {
    api.reload('2063f2fa', __exports__)
  }
  
  module.hot.accept("./WalletExplorer.vue?vue&type=template&id=2063f2fa", () => {
    api.rerender('2063f2fa', render)
  })

}


export default __exports__